// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"2398c98c","160":"5ffbb92a","395":"f5578c06","453":"b1679f88","500":"5daa64ca","515":"a148409b","545":"af25bb05","658":"8b8881b9","672":"981049a5","723":"935b9fdf","795":"e9a7a5c8","800":"f704a7eb","863":"b00043b4","930":"d87cb515"}[chunkId] + ".chunk.js";
};